import React, { useState } from "react";
import { invitememberProps } from "./invitemember-interface";
import { Alert, Button, Form, Input, Modal } from "antd";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {
  capitalizeFirstLetter,
  openNotificationWithIcon,
} from "../../../../../../utils/helper";
import {
  addStudentToClass,
  addTeacherToClass,
} from "../../../../../../api/class/class";

const Invitemember = ({
  open,
  closeModal,
  memberType,
  classCode,
  classId,
}: invitememberProps) => {
  const [form] = Form.useForm();

  const [error, setError] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    email: "",
  });

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      const { email } = values;

      let res;

      if (classId !== undefined) {
        if (memberType === "student") {
          res = await addStudentToClass(classId, email);
        } else {
          res = await addTeacherToClass(classId, email);
        }

        const { message } = res.data;

        openNotificationWithIcon(
          "success",
          `Invite ${capitalizeFirstLetter(memberType)}`,
          message ||
            `${capitalizeFirstLetter(memberType)} invited successfully.`
        );
      }

      setLoading(false);
      closeModal(true);
    } catch (error: any) {
      setLoading(false);
      const otherErrors: any[] = [];
      if (error?.response) {
        if (error?.response?.data?.errors) {
          const resError = error?.response?.data?.errors;

          Object.entries(resError).forEach(([key, value]) => {
            if (Object.keys(errors).includes(key)) {
              setErrors((prevState) => ({
                ...prevState,
                [key]: value,
              }));
            } else {
              otherErrors.push(value);
            }
          });

          if (otherErrors.length > 0) {
            const errorList = otherErrors.map((element: any, index) => {
              return <li key={`error-list-${index}`}>{element}</li>;
            });
            setError(errorList);
          }
        } else {
          setError(error?.response?.data?.message || "Something went wrong");
        }
      } else {
        setError("Something went wrong");
      }
    }
  };

  return (
    <div>
      <Modal
        closable={false}
        open={open}
        onOk={() => {
          if (!loading) {
            closeModal();
          }
        }}
        onCancel={() => {
          if (!loading) {
            closeModal();
          }
        }}
        footer={null}
        width={"30rem"}
        className="white-bg-modal"
      >
        <div>
          <div className="flex items-center justify-between border-b border-appcolorgreyfour pb-[0.75rem]">
            <h1 className="mb-[-1rem] text-[22px] font-semibold leading-[110%] text-appcolorgrey">
              Add <span className="capitalize">{memberType}</span>
            </h1>
            <div
              className="custom-box-shadow-five w-fit cursor-pointer rounded-full bg-appcolorgreyfive p-[0.9rem]"
              onClick={() => {
                if (!loading) {
                  closeModal();
                }
              }}
            >
              <img src="/img/vectors/modalclose.svg" alt="" />
            </div>
          </div>

          <div className="mt-[2rem]">
            {error !== null ? (
              <div className="mb-4">
                <Alert message={error} type="error" />
              </div>
            ) : null}
            <Form layout="vertical" onFinish={onFinish} form={form}>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Input is required" },
                  { type: "email", message: "Email is invalid" },
                ]}
                validateStatus={errors?.email.length > 0 ? "error" : undefined}
                help={errors?.email.length > 0 ? errors?.email : undefined}
              >
                <Input
                  onChange={() => {
                    setErrors((prevState) => ({
                      ...prevState,
                      email: "",
                    }));
                  }}
                  placeholder="Enter your email"
                />
              </Form.Item>

              <Form.Item>
                <div className="flex">
                  <Button
                    htmlType="submit"
                    className="custom-primary-two-btn smaller-padding"
                    loading={loading}
                  >
                    Submit
                  </Button>
                </div>
              </Form.Item>
            </Form>

            {classCode !== undefined ? (
              <>
                <div className="pt-4 mt-12 border-t border-appcolorgreyfour">
                  <p className="text-sm font-semibold text-appcolorblackfaint">
                    Other
                  </p>

                  <div className="mt-[1.1rem] ">
                    <p className="mb-2 text-sm text-appcolorpurplefaintone">
                      Share the class code
                    </p>

                    <div className="flex justify-between">
                      <div className="mr-[0.6rem] flex flex-1 rounded-[0.3rem] bg-appcolorgreyfaint px-2 py-1 text-xs text-appcolorgrey">
                        <span className="pr-2">#</span> <span>{classCode}</span>
                      </div>

                      <CopyToClipboard
                        text={classCode}
                        onCopy={() => {
                          openNotificationWithIcon(
                            "info",
                            "Copy Code",
                            "Class code copied to clipboard"
                          );
                        }}
                      >
                        <p className="flex cursor-pointer items-center rounded-[0.3rem] bg-appcolorgreyfaintsix px-2 py-1">
                          <span className="pr-[0.6rem]">Copy Code</span>
                          <img
                            src="/img/vectors/purplecopy.svg"
                            alt="purplecopy"
                          />
                        </p>
                      </CopyToClipboard>
                    </div>
                  </div>

                  <div className="mt-[1.1rem] ">
                    <p className="mb-2 text-sm text-appcolorpurplefaintone">
                      Share the class code
                    </p>

                    <div className="flex justify-between">
                      <div className="mr-[0.6rem] flex flex-1 rounded-[0.3rem] bg-appcolorgreyfaint px-2 py-1 text-xs text-appcolorgrey">
                        <span className="pr-2">#</span> <span>{classCode}</span>
                      </div>

                      <CopyToClipboard
                        text={classCode}
                        onCopy={() => {
                          openNotificationWithIcon(
                            "info",
                            "Copy Code",
                            "Class code copied to clipboard"
                          );
                        }}
                      >
                        <p className="flex cursor-pointer items-center rounded-[0.3rem] bg-appcolorgreyfaintsix px-2 py-1">
                          <span className="pr-[0.6rem]">Copy Link</span>
                          <img
                            src="/img/vectors/purpleshare.svg"
                            alt="purpleshare"
                          />
                        </p>
                      </CopyToClipboard>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Invitemember;
